import Link from "next/link";
import keyMapping from "utils/attributeKeyMap";

export default function Attributes({ attributes, title }) {
  if (!Array.isArray(attributes) || !attributes.length) {
    return null;
  }

  return (
    <li className="overflow-hidden bg-white px-4 py-4 shadow sm:rounded-md sm:px-6">
      <div className="px-4 py-5 sm:px-6">
        <h3 className="text-lg font-medium leading-6 text-gray-900">
          {title ?? "Attributes"}
        </h3>
      </div>
      <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
        <dl className="sm:divide-y sm:divide-gray-200">
          {attributes.map((attribute) => (
            <div
              key={attribute.ValueType}
              className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6"
            >
              <dt className="text-sm font-medium text-gray-500">
                {keyMapping[attribute.ValueType] || attribute.ValueType}
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                {attribute.Link ? (
                  <Link href={attribute.Link}>
                    <a
                      href={attribute.Link}
                      className="no-underline hover:underline"
                    >
                      {attribute.Value}
                    </a>
                  </Link>
                ) : (
                  attribute.Value
                )}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </li>
  );
}
